/** Tipos de documento do processo licitatório. */
export const TIPOS_DOCUMENTO_LICITACAO = /** @type {const} */ ([
  'edital',
  'etp',
  'termo_referencia',
]);

/** Ordem de processamento e consolidação incremental. */
export const ORDEM_PROCESSAMENTO_DOCUMENTOS = /** @type {const} */ ([
  'edital',
  'etp',
  'termo_referencia',
]);

/** Ordem para definir arquivo principal (create): edital → TR → ETP. */
export const ORDEM_ARQUIVO_PRINCIPAL = /** @type {const} */ ([
  'edital',
  'termo_referencia',
  'etp',
]);

export const LABELS_DOCUMENTO_LICITACAO = {
  edital: 'Edital',
  etp: 'ETP (Estudo Técnico Preliminar)',
  termo_referencia: 'Termo de Referência',
};

/** @typedef {'edital' | 'etp' | 'termo_referencia'} TipoDocumentoLicitacao */

/** @typedef {{ tipo: TipoDocumentoLicitacao, file?: File, url?: string, nome?: string, content_sha256?: string }} DocumentoProcessoEntrada */
